import {BrowserRouter, Routes, Route} from 'react-router-dom';
import './App.css';
import Header from './components/header';
import Footer from './components/footer';
import {NotificationProvider} from './contexts/NotificationContext';
import {LoginModalProvider} from './contexts/LoginModalContext';
import Home from './pages/Home';
import Buses from './pages/Buses';
import Book from './pages/Book';
import BookingConfirm from './pages/BookingConfirm';
import ProfilePage from './pages/ProfilePage';
import MyBookings from './pages/MyBookings';
import Contact from './pages/Contact';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Tos from './pages/Tos';
import {useAuth} from './hooks/useAuth';
import ProtectedRoute from './components/ProtectedRoute';
import LoginRequired from './pages/LoginRequired';

function App() {
    const {user} = useAuth();
    return (
        <BrowserRouter>
            <NotificationProvider>
                <LoginModalProvider>
                    <Header/>
                    <Routes>
                        <Route path="/"
                            element={<Home/>}/>
                        <Route path="/buses"
                            element={<Buses/>}/>
                        <Route path="/booking/process"
                            element={<Book/>}/>
                        <Route path="/booking-confirmation"
                            element={<BookingConfirm/>}/>
                        <Route path='/profile'
                            element={
                                <ProtectedRoute><ProfilePage/></ProtectedRoute>
                            }/>
                        <Route path="/my-bookings"
                            element={
                                <ProtectedRoute><MyBookings/></ProtectedRoute>
                            }/>
                        <Route path="/contact-us"
                            element={<Contact/>}/>
                        <Route path='/about-us'
                            element={<About/>}/>
                        <Route path='/privacy-policy'
                            element={<Privacy/>}/>
                        <Route path='/terms-conditions'
                            element={<Tos/>}/>
                        <Route path="/login-required"
                            element={<LoginRequired/>}/>

                    </Routes>
                    <Footer/>
                </LoginModalProvider>
            </NotificationProvider>
        </BrowserRouter>
    );
}


export default App;
